import {Request} from 'express';
import {IncomingMessage} from 'http';
import {
  DEFAULT_SERVER_SIDE_UA,
  UA_POSTFIX_FROM_GRAPHQL,
  UA_POSTFIX_FROM_PROXY,
  UA_POSTFIX_FROM_SCHEDULER,
  UA_POSTFIX_FROM_SSR,
} from './constant';

export function getUaFromServerSide({
  request,
  requestType,
}: {
  request?: Request | IncomingMessage;
  requestType: 'ssr' | 'graphql' | 'proxy' | 'scheduler';
}) {
  return `${request?.headers?.['user-agent'] || DEFAULT_SERVER_SIDE_UA} ${
    REQUEST_TYPE_MAP[requestType]
  }`;
}

const REQUEST_TYPE_MAP = {
  ssr: UA_POSTFIX_FROM_SSR,
  graphql: UA_POSTFIX_FROM_GRAPHQL,
  proxy: UA_POSTFIX_FROM_PROXY,
  scheduler: UA_POSTFIX_FROM_SCHEDULER,
};
